function backendBearerCredential(sessionId, organizationId, token) {
  const t = typeof token === "string" ? token.trim() : "";
  if (t.includes("&")) return t;
  const sid = String(sessionId || "").trim();
  const oid = String(organizationId || "").trim();
  return `${sid}&${oid}`;
}

export async function savePassPlayResult({
  sessionId,
  organizationId,
  userId,
  token,
  playerXName,
  playerOName,
  winner,
  player1points,
  player2points,
  totalTime,
}) {
  const bearer = backendBearerCredential(sessionId, organizationId, token);
  const resp = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/savePassPlayResult`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearer}`,
      },
      body: JSON.stringify({
        sessionId,
        organizationId,
        userId,
        playerXName,
        playerOName,
        winner,
        player1points,
        player2points,
        totalTime,
      }),
    }
  );

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || data?.error || "Failed to save pass & play result");
  }
  return data;
}
